export default {
    SET_AVAILABLE_CAMPAIGNS(state, campaigns) {
        state.available_campaigns = campaigns;
    },

    SET_AVAILABLE_TEMPLATES(state, templates) {
        state.available_templates = templates;
    },

    SET_FILTERED_TEMPLATES(state, templates) {
        state.filtered_templates = templates;
    },

    SET_AVAILABLE_PAPER_FORMATS(state, formats) {
        state.available_formats = formats;
    },

    SET_FILTERED_PAPER_FORMATS(state, formats) {
        state.filtered_formats = formats;
    },

    SET_AVAILABLE_THEMES(state, themes) {
        state.available_themes = themes;
    },

    SET_FILTERED_THEMES(state, themes) {
        state.filtered_themes = themes;
    },

    SET_TEMPLATE(state, template) {
        state.template = template;
    },

    SET_CONTENT(state, content) {
        if (state.template) {
            state.template.content = content;
        }
    },

    SET_THEME(state, theme) {
        state.theme = theme;
    },

    SET_CAMPAIGN(state, campaign) {
        state.campaign = campaign;
    },
  
    SET_CAMPAIGN_ID(state, campaign) {
        state.campaign_id = campaign;
    },

    SET_IMAGES(state, images) {
        state.templateImages = images;
    },

    SET_IS_HYBRID(state, isHybrid) {
        state.isHybrid = isHybrid;
    },

    SET_TEMPLATE_COLORS(state, colors) {
        state.templateColors = colors;
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/selector/mutations.js